import React from 'react'

export function Editing() {
  return (
    <React.Fragment>
      Coming soon
    </React.Fragment>
  )
}
